import api from './utilBackoffice';

const controller = 'BaseCalculo';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  Download: dto => {
    return api.Axios.DownloadExcelFile(url + '/Download', dto);
  }
});
